import Vue from 'vue';
import Vuex from 'vuex';
import healthReport from "./modules/healthReport";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {healthReport},
  state: {
    user: {},
    classList: [],
    isv20: 0,
  },
  mutations: {
    setUser(state, user) {
      localStorage.setItem('userInfo', JSON.stringify(user));
      state.user = user;
    },
    setV20(state, isv20) {
      localStorage.setItem('isv20', isv20);
      state.isv20 = isv20;
    },
    setClass(state, classList) {
      state.classList = classList;
    }
  },
  getters: {
    queryClassInfo:state => state.healthReport.queryClassInfo,
    getUser: state => {
      let user = state.user;
      // console.log("user",user);
      if (!user.name) {
        user = JSON.parse(localStorage.getItem("userInfo")) || {};
        state.user = user;
      }
      return user;
    },
    getV20: state => {
      let v20 = state.isv20;
      console.log("v20", v20);
      if (!state.isv20) {
        v20 = localStorage.getItem("isv20");
        state.isv20 = v20;
      }
      return v20;
    }
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js